import { useState } from "react";
import { Link } from "react-router-dom";

import WellnessSlider from "../components/WellnessSlider";
import PatientCare from "../components/PatientCare";

function Home() {
    const [active, setActive] = useState(null);

    const cardGradient =
        "linear-gradient(135deg, #e6f0ff 0%, #efe3ff 50%, #ffffff 100%)";

    return (
        <div className="min-h-screen bg-transparent">

            {/* ================= HERO ================= */}
            <WellnessSlider />

            {/* ================= HOSPITAL INTRO ================= */}
            <section className="py-10">
                <div className="max-w-6xl mx-auto px-4">
                    <div
                        className="rounded-3xl shadow-2xl overflow-hidden grid grid-cols-1 md:grid-cols-2"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        {/* LEFT IMAGE */}
                        <div className="flex items-center justify-center p-6">
                            <div className="w-full h-80 bg-black/20 rounded-2xl flex items-center justify-center overflow-hidden">
                                <img
                                    src="/images/Home/Main.jpg"
                                    alt="Gavli Hospital Kurawar"
                                    className="w-full h-full object-contain rounded-xl"
                                />
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="p-10 bg-black/30 backdrop-blur-md flex flex-col justify-center">
                            <h2 className="text-3xl font-bold text-white mb-4">
                                Expert Care at Gavli Hospital Kurawar
                            </h2>

                            <p className="text-white/95 mb-4 leading-relaxed">
                                Gavli Hospital Kurawar is a trusted hospital providing quality
                                healthcare services with experienced doctors and modern facilities.
                            </p>

                            <p className="text-white/90 mb-6 leading-relaxed">
                                We ensure accurate diagnosis, compassionate treatment and
                                emergency care for every patient.
                            </p>

                            <div className="flex gap-4 flex-wrap">
                                <Link
                                    to="/doctors"
                                    className="px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
                                >
                                    View Doctors
                                </Link>

                                <a
                                    href="tel:108"
                                    className="px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition"
                                >
                                    Emergency 108
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= INFRASTRUCTURE & FACILITIES ================= */}
            <section className="py-10">
                <div className="max-w-7xl mx-auto px-4">

                    {/* 🔵 OUTER GRADIENT BOX (SAME FEEL AS SPECIALITIES) */}
                    <div
                        className="rounded-3xl p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        {/* HEADING */}
                        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-12 text-white">
                            Infrastructure & Facilities
                        </h2>

                        {/* INNER LIGHT GRADIENT BOX */}
                        <div
                            className="rounded-3xl p-10"
                            style={{
                                background:
                                    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                            }}
                        >
                            {/* CARDS */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                                {[
                                    {
                                        title: "Sonography Facilities",
                                        desc: "Advanced ultrasound and sonography services for accurate diagnosis of abdominal, pregnancy and organ-related conditions.",
                                    },
                                    {
                                        title: "ICU & NICU",
                                        desc: "Fully equipped Intensive and Neonatal Care Units with continuous monitoring and life-support systems.",
                                    },
                                    {
                                        title: "Operation Theatres",
                                        desc: "Modern and sterile operation theatres designed for safe surgical procedures using advanced equipment.",
                                    },
                                    {
                                        title: "In-House Pharmacy",
                                        desc: "24×7 in-house medical store providing genuine medicines for immediate patient needs.",
                                    },
                                    {
                                        title: "Diagnostics & Imaging",
                                        desc: "Comprehensive diagnostic services including pathology tests, ECG, X-ray and imaging facilities.",
                                    },
                                    {
                                        title: "Emergency & Ambulance",
                                        desc: "Round-the-clock emergency services with fully equipped ambulance for rapid patient care.",
                                    },
                                ].map((item, i) => (
                                    <div
                                        key={i}
                                        className="rounded-2xl p-7 shadow-xl border-2 border-[#0b3c78]/20"
                                        style={{
                                            background:
                                                "linear-gradient(135deg, #ffffff, #eef5ff, #e3edff)",
                                        }}
                                    >
                                        <h4 className="text-lg font-bold text-[#0b3c78] mb-3">
                                            {item.title}
                                        </h4>
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            {item.desc}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ================= ACHIEVEMENTS ================= */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-4">
                    <div
                        className="rounded-3xl p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        <h2 className="text-3xl font-semibold text-center mb-10 text-white">
                            Our Achievements
                        </h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {[
                                ["NABH Standards", "/images/Home/achievements/NABH.jpg", true],
                                ["32+ Beds", "/images/Home/achievements/beds.jpg"],
                                ["15+ Years Experience", "/images/Home/achievements/experience.jpg"],
                                ["24×7 Emergency", "/images/Home/achievements/news.jpg"],
                            ].map(([title, img, logo], i) => (
                                <div key={i} className="rounded-2xl overflow-hidden shadow-xl bg-white">
                                    <div className="h-52 flex items-center justify-center">
                                        <img
                                            src={img}
                                            alt={title}
                                            className={`w-full h-full ${logo ? "object-contain p-4" : "object-cover"}`}
                                        />
                                    </div>
                                    <div className="py-4 bg-gradient-to-r from-[#0b3c78] to-[#1e6fd9]">
                                        <p className="text-white text-lg font-semibold text-center">
                                            {title}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= QUICK ACCESS ================= */}
            <section className="py-10">
                <div
                    className="max-w-7xl mx-auto px-6 rounded-3xl shadow-2xl"
                    style={{
                        background:
                            "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                    }}
                >
                    <h2 className="text-3xl font-bold text-center text-white mb-12 pt-6">
                        Quick Access
                    </h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-10">

                        <Link
                            to="/contact"
                            onClick={() => setActive("contact")}
                            className={`block rounded-2xl shadow-xl p-8 text-center transition-all
              ${active === "contact"
                                    ? "bg-red-600 text-white"
                                    : "bg-white text-gray-700 hover:bg-blue-600 hover:text-white"
                                }`}
                        >
                            <h3 className="text-xl font-semibold mb-3">Contact Us</h3>
                            <p>Appointments & enquiries</p>
                        </Link>

                        <a
                            href="tel:108"
                            onClick={() => setActive("ambulance")}
                            className={`block rounded-2xl shadow-xl p-8 text-center transition-all
              ${active === "ambulance"
                                    ? "bg-red-600 text-white"
                                    : "bg-white text-gray-700 hover:bg-red-600 hover:text-white"
                                }`}
                        >
                            <h3 className="text-xl font-semibold mb-3">Ambulance</h3>
                            <p>24×7 emergency service</p>
                        </a>

                        <Link
                            to="/medical-facilities"
                            onClick={() => setActive("facilities")}
                            className={`block rounded-2xl shadow-xl p-8 text-center transition-all
              ${active === "facilities"
                                    ? "bg-red-600 text-white"
                                    : "bg-white text-gray-700 hover:bg-blue-600 hover:text-white"
                                }`}
                        >
                            <h3 className="text-xl font-semibold mb-3">Medical Facilities</h3>
                            <p>All available services</p>
                        </Link>

                        <Link
                            to="/doctors"
                            onClick={() => setActive("doctors")}
                            className={`block rounded-2xl shadow-xl p-8 text-center transition-all
              ${active === "doctors"
                                    ? "bg-red-600 text-white"
                                    : "bg-white text-gray-700 hover:bg-blue-600 hover:text-white"
                                }`}
                        >
                            <h3 className="text-xl font-semibold mb-3">Find a Doctor</h3>
                            <p>Search by expertise</p>
                        </Link>

                    </div>
                </div>
            </section>

            {/* ================= PATIENT CARE ================= */}
            <PatientCare />

            {/* ================= SPECIALITIES ================= */}
            <section className="py-10">
                <div className="max-w-7xl mx-auto px-4">
                    <div
                        className="rounded-3xl p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        <h2 className="text-3xl font-semibold text-center mb-12 text-white">
                            Hospital Specialities
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {[
                                {
                                    title: "Cardiology",
                                    desc: "Heart care & ECG",
                                    img: "/images/Home/Specialities/cardiology.jpg",
                                },
                                {
                                    title: "Orthopedics",
                                    desc: "Bone & joint care",
                                    img: "/images/Home/Specialities/Orthopedics.jpg",
                                },
                                {
                                    title: "Gynecology",
                                    desc: "Women health care",
                                    img: "/images/Home/Specialities/Gynecology.jpg",
                                },
                                {
                                    title: "Pediatrics",
                                    desc: "Child care services",
                                    img: "/images/Home/Specialities/Pediatrics.jpg",
                                },
                                {
                                    title: "Neurology",
                                    desc: "Brain & nerve care",
                                    img: "/images/Home/Specialities/Neurology.jpg",
                                },
                                {
                                    title: "General Medicine",
                                    desc: "Common illness care",
                                    img: "/images/Home/Specialities/General-Medicine.jpg",
                                },
                            ].map((item, i) => (
                                <div
                                    key={i}
                                    className="rounded-2xl overflow-hidden shadow-xl border-2 border-black"
                                    style={{ background: cardGradient }}
                                >
                                    {/* IMAGE */}
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        className="w-full h-48 object-cover"
                                    />

                                    {/* TEXT */}
                                    <div className="p-6 text-center">
                                        <h4 className="text-[#0b3c78] font-bold text-lg mb-2">
                                            {item.title}
                                        </h4>
                                        <p className="text-[#1f2937] text-sm font-medium">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= HEALTH PACKAGES ================= */}
            <section className="py-10">
                <div className="max-w-7xl mx-auto px-4">
                    <div
                        className="rounded-3xl p-10 shadow-2xl"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        <h2 className="text-3xl font-semibold text-center mb-12 text-white">
                            Health Packages
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {[
                                ["Full Body Checkup", "Complete health screening"],
                                ["Women Health Package", "Special women wellness care"],
                                ["Senior Citizen Package", "Preventive care for elderly"],
                            ].map(([title, desc], i) => (
                                <div
                                    key={i}
                                    className="rounded-2xl p-8 text-center shadow-lg border-2 border-black"
                                    style={{ background: cardGradient }}
                                >
                                    <h3 className="text-[#0b3c78] font-bold text-xl mb-3">
                                        {title}
                                    </h3>
                                    <p className="text-[#1f2937] text-sm font-medium">
                                        {desc}
                                    </p>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default Home;
